module.exports = __webpack_public_path__ + "static/media/施工前.6c44e814.jpg";